<template>
<div>
  <btn @click="importSheets">Fichier csv générique</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <h2>Import Néo Inf ADI générique</h2>
    <div class="row">
      <div class="col-xs-12">
        <p>
          <input ref="fileInput" type="file" single>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
      </div>
    </div>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
</div>
</template>
<script>
import StepIterator from '@/sui/tools/stepiterator'
import steps from '@/sui/components/steps'
import baseSteps from '@/components/sheets/import/impl/steps'
import impl from '@/components/sheets/import/impl/neoinfadi'
import validator from '@/sui/components/sheet/validate/impl/validator'
import types from '@/sui/data/modules'
import assert from '@/sui/tools/assert'

export default {
  name: 'sheets-import-neoinfadi',
  props: {
    surveillance: {
      type: Object,
      required: true
    }
  },

  data: function () {
    const steps = [
      baseSteps.load(
        'Fichier Néo Inf ADI', 'Impossible de charger le fichier'
      ),
      baseSteps.transform(
        'Ajout des patients', 'Impossible de traiter le fichier patient',
        (count) => `${count} patients ajoutés avec succès.`,
        (vm, data, o, start, end) => {
          if (start === 0) {
            data.sheets = {}
            vm.d = []
            const module = types.get(this.surveillance.year)['neoInfADI']
            assert.notNull(
              module,
              `selectReference: invalid sheet type (${this.module})`
            )
            vm.reference = module.sheets.edit
          }

          for (let i = start; i !== end; ++i) {
            const sheet = o[i]
            const transformed = impl.createSheet(
              this.surveillance.year,
              sheet
            )
            data.sheets[i] = transformed
            vm.d.push({ f: transformed, t: 'neoInfADI', y: this.surveillance.year })
          }
        }
      ),
      validator.steps.validate(vm => vm.d, true),
      baseSteps.purge('neoInfADI'),
      baseSteps.insert('neoInfADI')
    ]

    return {
      show: false,
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    importSheets: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'steps': steps
  }
}
</script>
<style lang="less" scoped>
</style>
